import 'bootstrap/js/tooltip';
// Recusively finds the closest parent that has the specified class
/**
 * @param child
 * @param className
 */
function closestParent(child, className) {
  if (!child || child === document) {
    return null;
  }
  if (child.classList.contains(className)) {
    return child;
  }
  return closestParent(child.parentNode, className);
}

/**
 * @param formGroup
 */
export function resetFormGroup(formGroup) {
  // Remove the success and error classes
  formGroup.classList.remove('has-error');
  formGroup.classList.remove('has-success');
}
// Adds tooltip with specified error
/**
 * @param input
 * @param error
 */
function addError(input, error) {
  input.title = error;
  $(input).tooltip('fixTitle').tooltip('show');
}

// Shows the errors for a specific input
/**
 * @param input
 * @param errors
 */
export function showErrorsForInput(input, errors) {
  // This is the root of the input
  const formGroup = closestParent(input.parentNode, 'form-group');
  // First we remove any old messages and resets the classes
  if (formGroup) {
    resetFormGroup(formGroup);
    // If we have errors
    if (errors) {
      // we first mark the group has having errors
      formGroup.classList.add('has-error');
      // then we append all the errors
      errors.forEach(error => {
        addError(input, error);
      });
    } else {
      // otherwise we simply mark it as success
      formGroup.classList.add('has-success');
      $(input).tooltip('destroy');
    }
  }
}

/**
 * Updates the inputs with the validation errors.
 *
 * @param form
 * @param errors
 */
export function showErrors(form, errors) {
  // We loop through all the inputs and show the errors for that input
  Array.from(form.querySelectorAll('input[name]:not([type="hidden"]), select[name]'))
    .forEach(input => {
      // Since the errors can be null if no errors were found we need to handle
      // that
      if (!input.hidden) showErrorsForInput(input, errors && errors[input.name]);
    });
}
